<template>
  <div
    id="time-dropdown"
    class="dropdown"
  >
    <button
      id="time-dropdown-button"
      class="dropdown-button"
    >
      <span
        class="btn__icon-image mr-1"
        v-html="calendarIcon"
      />
      {{ selectedPeriodLabel }}
      <span
        class="dropdown-button-chevron"
        v-html="chevronDown"
      />
    </button>
    <div class="dropdown-content dropdown-content--left">
      <template v-for="(periodLabel, periodKey) in periodLabels">
        <div
          :id="periodKey + '-filter-item'"
          :key="periodKey"
          :class="[selectedClass(periodKey), 'dropdown-item']"
          @click="selectPeriod(periodKey)"
        >
          {{ periodLabel }}
        </div>
      </template>
      <div class="dropdown__divider" />
      <div
        id="edit-details-dropdown"
        class="dropdown-item dropdown-item--column"
      >
        <div class="form-container">
          <label class="form-label">From</label>
          <datetime
            v-model="customPeriod.start"
            input-id="start-custom-date-input"
            title="Start Date"
            value-zone="local"
            type="date"
            input-class="form-field"
            :week-start="7"
            :max-datetime="maxCustomDate"
          />
        </div>
        <div class="form-container">
          <label class="form-label">To</label>
          <datetime
            v-model="customPeriod.end"
            input-id="end-custom-date-input"
            title="End Date"
            value-zone="local"
            type="date"
            input-class="form-field"
            :week-start="7"
            :max-datetime="maxCustomDate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import feather from 'feather-icons'
import moment from 'moment'
import {Datetime} from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

export default {
  name: 'TimePeriodDropdown',
  components: {
    Datetime,
  },
  props: ['start', 'end'],
  data() {
    return {
      selectedPeriod: 'day',
      maxCustomDate: moment().toISOString(),
      periodLabels: {
        day: 'Past Day',
        week: 'Past Week',
        month: 'Past Month',
        year: 'Past Year',
      },
      customPeriod: {
        start: null,
        end: null,
      },
      chevronDown: feather.icons['chevron-down'].toSvg(),
      calendarIcon: feather.icons.calendar.toSvg(),
    }
  },
  computed: {
    selectedPeriodLabel() {
      if (this.selectedPeriod === 'custom') {
        return 'Custom Range'
      }
      return this.periodLabels[this.selectedPeriod]
    },
  },
  watch: {
    selectedPeriod: {
      immediate: true,
      handler() {
        if (this.selectedPeriod !== 'custom') {
          const _periods = {
            day: moment().subtract(1, 'day'),
            week: moment().subtract(1, 'week').startOf('day'),
            month: moment().subtract(1, 'month').startOf('day'),
            year: moment().subtract(1, 'year').startOf('day'),
          }
          const _startDate = _periods[this.selectedPeriod]
          this.emitTimePeriod(_startDate, moment())
          this.customPeriod.start = ''
          this.customPeriod.end = ''
        }
      },
    },
    customPeriod: {
      deep: true,
      handler() {
        const {start, end} = this.customPeriod
        if (moment(start).isSameOrBefore(end) && moment(end).isSameOrBefore()) {
          this.selectedPeriod = 'custom'
          const _start = moment(start).startOf('day')
          const _end = moment(end).endOf('day')
          this.emitTimePeriod(_start, _end)
        }
      },
    },
  },
  methods: {
    selectedClass(duration) {
      return duration === this.selectedPeriod ? 'dropdown-item--selected' : ''
    },
    selectPeriod(duration) {
      this.selectedPeriod = duration
    },
    emitTimePeriod(startTime, endTime) {
      this.$emit('update:start', startTime)
      this.$emit('update:end', endTime)
    },
  },
}
</script>
